<template>
  <div>
    <el-form-item label="游戏组（可多选）">
      <el-select v-model="formData.group" multiple filterable :style="{ width: selectorWidth }" @change="handleGroup">
        <el-option v-for="item in gameGroups" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="游戏（可多选）" prop="game" :key="formData.imageType + 'game'">
      <el-select
        v-if="gameListVisible"
        v-model="formData.game"
        multiple
        filterable
        clearable
        :style="{ width: selectorWidth }"
        :collapse-tags="isGameListCollapse"
        @change=";(formData.label = []), onGameChange($event)"
      >
        <el-option v-for="item in gameList" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
      <el-button @click="onGameListSelectorCollapseToggle(false)" v-if="isGameListCollapse" type="text">展开显示</el-button>
      <el-button @click="onGameListSelectorCollapseToggle(true)" v-else type="text">收起显示</el-button>
    </el-form-item>
  </div>
</template>

<script setup>
import { ref, nextTick, computed } from 'vue'
import { initPageData, GAME_GROUPS, GAMES } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, GAMES])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const gameList = computed(PAGE_REQUIRED_OPTS.GAMES)

// eslint-disable-next-line
const props = defineProps({
  formData: { type: Object },
  selectorWidth: {
    type: String,
    default: '420px'
  }
})

// eslint-disable-next-line
const emits = defineEmits(['group-change', 'game-change'])

const isGameListCollapse = ref(true) // 游戏列表是否收起
// 通过v-if使组件初始化生命周期，不然直接切换collapse-tags状态会有显示问题
const gameListVisible = computed(() => typeof isGameListCollapse.value === 'boolean')
const onGameListSelectorCollapseToggle = (flag) => {
  isGameListCollapse.value = 0
  nextTick(() => (isGameListCollapse.value = flag))
}

function handleGroup(val) {
  emits('group-change', val)
}

function onGameChange(e) {
  emits('game-change', e)
}
</script>

<style scoped></style>
